import { ComponentProps } from 'react';

import { cn } from '../lib';
import { Switch } from './switch';
import { Typography } from './typography';

interface SwitchWithLabelProps extends ComponentProps<typeof Switch> {
  label: string;
}
export const SwitchWithLabel = ({
  label,
  onCheckedChange,
  className,
  ...props
}: SwitchWithLabelProps) => {
  return (
    <div
      className={cn(
        'flex items-center justify-between rounded-[20px] bg-base-300 px-5 py-6',
        { 'bg-base-50': props.disabled },
        className,
      )}
    >
      <Typography>{label}</Typography>
      <Switch onCheckedChange={onCheckedChange} {...props} />
    </div>
  );
};
